import BaseService from '../common/BaseService';
import { COMMUNICATION_PREFERENCES } from '../common/endpoints';
import { AxiosResponse } from 'axios';

export default class IndividualPortalService extends BaseService {
    constructor(props) {
        super(props);
    }

    getCommunicationPreferences(): Promise<any> {
        return this.client.get(COMMUNICATION_PREFERENCES).then((response: AxiosResponse) => response.data);
    }
}